import { styled } from "baseui";

export const LabelText = styled("p", ({ $theme }) => ({
  ...$theme.typography.font350,
  margin: 0,
}));
